import React from 'react';
import TrainRouteRecommend from '../subcomponents/TrainRouteRecommend';
import RoutesIntelinkBlocks from '../subcomponents/RoutesInterlinkBlocks';
import RailwayStationRouteRecommend from '../subcomponents/RailwayStationRouteRecommend';
import { NearbyCitiesRoutesRecommend } from '../subcomponents/NearbyCitiesRoutesRecommend';
import { StationRouteRecommend } from '../subcomponents/StationRouteRecommend';
import RandomTrainRecommend from '../subcomponents/RandomTrainRecommend';
import CrossLobRecommend from '../subcomponents/CrossLobRecommend';

export const getAnchorTagTrainRoutes = ({ stringToFormat, replaceSourceWith, replaceDestWith }) => {
  return stringToFormat?.replace('${source}', replaceSourceWith).replace('${destination}', replaceDestWith);
};

export const trainRouteCallback = (data, recommendRouteObject) => {
  const { source: vernacularSourceCityName, destination: vernacularDestinationCityName } = data.tokens;
  return function trainRouteRecommendWrapper({ source, destination, link, routePageUrl }, idx) {
    return (
      <TrainRouteRecommend
        trainRouteProps={{ source, destination, link, routePageUrl }}
        additionalProps={{ vernacularSourceCityName, vernacularDestinationCityName, recommendRouteObject, idx }}
      />
    );
  };
};

export const trainTypeRouteToCallback = (destinationCity) => {
  return function trainRouteRecommendWrapper(item, idx) {
    const { url, label, source } = item;
    const destination = destinationCity;
    return <RoutesIntelinkBlocks trainRouteProps={{ source, destination, url, label, idx }} />;
  };
};

export const trainTypeRouteFromCallback = (sourceCity) => {
  return function trainRouteRecommendWrapper(item, idx) {
    const { url, label, destination } = item;
    const source = sourceCity;
    return <RoutesIntelinkBlocks trainRouteProps={{ source, destination, url, label, idx }} />;
  };
};

export const randomRouteCallback = (data, recommendRouteObject, destinationCity) => {
  return function randomRouteRecommendWrapper({ source, destination, link }, idx) {
    return (
      <TrainRouteRecommend
        trainRouteProps={{ source, destination, link }}
        additionalProps={{ recommendRouteObject, idx }}
      />
    );
  };
};

export const getRailwayStationRecommendObject = (recommendData) => {
  const { title = '', obj: { railwayStations: list = [] } = {} } = {
    ...recommendData
  };
  return { title, list };
};

export const railwayStationRouteCallback = () =>
  function railwayStationWrapper({ stationPageUrl, code, name }, idx) {
    return <RailwayStationRouteRecommend railwayStationRouteProps={{ stationPageUrl, code, name }} idx={idx} />;
  };

export const nearByCitiesRouteCallback = () =>
  function nearByCityRecommendWrapper(item, idx) {
    return <NearbyCitiesRoutesRecommend item={item} idx={idx} />;
  };

export const crossLobCallBacks = () =>
  function crossLobCallBacksWrapper({ label, url }, idx) {
    return <CrossLobRecommend label={label} url={url} idx={idx} />;
  };

export const stationRoutesCallback = (data, recommendObject) =>
  function stationRouteRecommendWrapper({ destination, source, routePageUrl }, idx) {
    return (
      <StationRouteRecommend
        stationRouteProps={{ destination, source, routePageUrl }}
        recommendObject={recommendObject}
        data={data}
        idx={idx}
      />
    );
  };

export const randomTrainCallback = () =>
  function randomTrainWrapper({ trainPageUrl, trainNumber, trainName }, idx) {
    return (
      <RandomTrainRecommend trainPageUrl={trainPageUrl} trainNumber={trainNumber} trainName={trainName} idx={idx} />
    );
  };

function getAlternateLanguageLinkBlocks(data, alternatePageInterlinks) {
  const alternateRoutePageRecommendCollection = alternatePageInterlinks.map((recommendObj) => {
    return {
      recommendPathData: recommendObj,
      callbackToDisplayListItem: trainRouteCallback(data, recommendObj)
    };
  });
  return alternateRoutePageRecommendCollection;
}

const recommendRouteInfoPath = (data) => {
  const { alternateRoutePageInterlinks = [] } = data;
  const alternateRoutePageRecommendCollection = getAlternateLanguageLinkBlocks(data, alternateRoutePageInterlinks);
  return [
    {
      eventName: '',
      recommendPathData: data.popularTrainsFromSrcToDest,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: 'rail_seo_route_availableroutes_clicked',
      recommendPathData: data.otherDestFromSrc,
      callbackToDisplayListItem: trainRouteCallback(data, data.otherDestFromSrc)
    },
    {
      eventName: 'rail_seo_route_availableroutes_clicked',
      recommendPathData: data.otherSrcToDest,
      callbackToDisplayListItem: trainRouteCallback(data, data.otherSrcToDest)
    },
    {
      eventName: 'rail_seo_route_toptrainroutes_clicked',
      recommendPathData: data.topTrainRoutes,
      callbackToDisplayListItem: trainRouteCallback(data, data.otherSrcToDest)
    },
    {
      eventName: 'rail_seo_route_returnroutes_clicked',
      recommendPathData: data.otherDestFromDest,
      callbackToDisplayListItem: trainRouteCallback(data, data.otherDestFromDest)
    },
    {
      eventName: 'rail_seo_route_returnroutes_clicked',
      recommendPathData: data.otherSrcToSrc,
      callbackToDisplayListItem: trainRouteCallback(data, data.otherSrcToSrc)
    },
    {
      eventName: 'rail_seo_route_allrailwaystations_clicked',
      recommendPathData: getRailwayStationRecommendObject(data.source),
      callbackToDisplayListItem: railwayStationRouteCallback()
    },
    {
      eventName: 'rail_seo_route_allrailwaystations_clicked',
      recommendPathData: getRailwayStationRecommendObject(data.destination),
      callbackToDisplayListItem: railwayStationRouteCallback()
    },
    {
      eventName: '',
      recommendPathData: data.ltsFromSource,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: '',
      recommendPathData: data.ltsToDestination,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: '',
      recommendPathData: data.stationsNearbySource,
      callbackToDisplayListItem: railwayStationRouteCallback()
    },
    {
      eventName: '',
      recommendPathData: data.stationsNearbyDestination,
      callbackToDisplayListItem: railwayStationRouteCallback()
    },
    {
      eventName: 'rail_seo_route_nearbycities_clicked',
      recommendPathData: data.nearByCities,
      callbackToDisplayListItem: nearByCitiesRouteCallback()
    },
    {
      eventName: 'rail_seo_route_cabs_clicked',
      recommendPathData: data.cabsRoutesFromCity,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: 'rail_seo_route_cabs_clicked',
      recommendPathData: data.cabsRoutesToCity,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: 'rail_seo_route_bus_clicked',
      recommendPathData: data.busRoutesFromCity,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: 'rail_seo_route_bus_clicked',
      recommendPathData: data.busRoutesToCity,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: 'rail_seo_route_hotels_clicked',
      recommendPathData: data.hotelsInSourceCity,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: 'rail_seo_route_hotels_clicked',
      recommendPathData: data.hotelsInDestinationCity,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: '',
      recommendPathData: data.sourceWhere2GoInfo,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    {
      eventName: '',
      recommendPathData: data.destinationWhere2GoInfo,
      callbackToDisplayListItem: crossLobCallBacks()
    },
    ...alternateRoutePageRecommendCollection
  ];
};

const recommendedTrainTypeInfoPath = (data) => {
  return [
    {
      eventName: '',
      recommendPathData: data.routesFromFirstSrcCity,
      callbackToDisplayListItem: trainTypeRouteFromCallback(data?.tokens?.firstSourceCity)
    },
    {
      eventName: '',
      recommendPathData: data.routesToFirstDstnCity,
      callbackToDisplayListItem: trainTypeRouteToCallback(data?.tokens?.firstDestinationCity)
    },
    {
      eventName: '',
      recommendPathData: data.routesFromSecondSrcCity,
      callbackToDisplayListItem: trainTypeRouteFromCallback(data?.tokens?.secondSourceCity)
    },
    {
      eventName: '',
      recommendPathData: data.routesToSecondDstnCity,
      callbackToDisplayListItem: trainTypeRouteToCallback(data?.tokens?.routesToSecondDestinationCity)
    },
    {
      eventName: '',
      recommendPathData: data.trainsStartingFromStn,
      callbackToDisplayListItem: randomTrainCallback()
    },
    {
      eventName: '',
      recommendPathData: data.trainsEndingAtStn,
      callbackToDisplayListItem: randomTrainCallback()
    },
    {
      eventName: '',
      recommendPathData: data.stationsInterlinkingData,
      callbackToDisplayListItem: railwayStationRouteCallback()
    },
    {
      eventName: '',
      recommendPathData: data.ltsInterlinkingData,
      callbackToDisplayListItem: crossLobCallBacks()
    }
  ];
};

const recommendStationInfoPath = (data) => [
  {
    eventName: 'rail_seo_station_toptrainroutes_clicked',
    recommendPathData: data.routesFromStationCity,
    callbackToDisplayListItem: stationRoutesCallback(data, data.routesFromStationCity)
  },
  {
    eventName: 'rail_seo_station_toptrainroutes_clicked',
    recommendPathData: data.routesToStationCity,
    callbackToDisplayListItem: stationRoutesCallback(data, data.routesToStationCity)
  },
  {
    eventName: 'rail_seo_station_allrailwaystations_clicked',
    recommendPathData: getRailwayStationRecommendObject(data.stationCityInfo),
    callbackToDisplayListItem: railwayStationRouteCallback()
  },
  {
    eventName: '',
    recommendPathData: data.trainsFromStationInterlinkBlocks,
    callbackToDisplayListItem: randomTrainCallback()
  },
  {
    eventName: '',
    recommendPathData: data.trainsToStationInterlinkBlocks,
    callbackToDisplayListItem: randomTrainCallback()
  },
  {
    eventName: '',
    recommendPathData: data.randomStationsList,
    callbackToDisplayListItem: railwayStationRouteCallback()
  },
  {
    eventName: 'rail_seo_station_otherroutes_clicked',
    recommendPathData: data.randomRoutesList,
    callbackToDisplayListItem: stationRoutesCallback(data, data.randomRoutesList)
  },
  {
    eventName: 'rail_seo_station_nearbycities_clicked',
    recommendPathData: data.nearByCities,
    callbackToDisplayListItem: nearByCitiesRouteCallback()
  }
];

const recommendTrainInfoPath = (data) => [
  {
    eventName: 'rail_seo_train_allrailwaystations_clicked',
    recommendPathData: getRailwayStationRecommendObject(data.sourceCity),
    callbackToDisplayListItem: railwayStationRouteCallback()
  },
  {
    eventName: 'rail_seo_train_allrailwaystations_clicked',
    recommendPathData: getRailwayStationRecommendObject(data.destinationCity),
    callbackToDisplayListItem: railwayStationRouteCallback()
  },
  {
    eventName: '',
    recommendPathData: data.randomRoutesList,
    callbackToDisplayListItem: stationRoutesCallback(data, data.randomRoutesList)
  },
  {
    eventName: 'rail_seo_train_othertrains_clicked',
    recommendPathData: data.randomTrainsList,
    callbackToDisplayListItem: randomTrainCallback()
  },
  {
    eventName: '',
    recommendPathData: data.otherDestinationsFromSource,
    callbackToDisplayListItem: trainRouteCallback(data, data.otherDestinationsFromSource)
  },
  {
    eventName: '',
    recommendPathData: data.otherDestinationsFromDestination,
    callbackToDisplayListItem: trainRouteCallback(data, data.otherDestinationsFromDestination)
  },
  {
    eventName: '',
    recommendPathData: data.otherSourcesToSource,
    callbackToDisplayListItem: trainRouteCallback(data, data.otherSourcesToSource)
  },
  {
    eventName: '',
    recommendPathData: data.otherSourcesToDestination,
    callbackToDisplayListItem: trainRouteCallback(data, data.otherSourcesToDestination)
  },
  {
    eventName: '',
    recommendPathData: data.trainsFromSrcToDstn,
    callbackToDisplayListItem: randomTrainCallback()
  }
];

const recommendReservationCancellationPath = (data) => [
  {
    recommendPathData: data.randomStationsList,
    callbackToDisplayListItem: railwayStationRouteCallback()
  },
  {
    recommendPathData: data.randomRoutesList,
    callbackToDisplayListItem: stationRoutesCallback(data, data.randomRoutesList)
  },
  {
    recommendPathData: data.randomTrainsList,
    callbackToDisplayListItem: randomTrainCallback()
  }
];

const recommendStaticListIndex = (data) => [
  {
    recommendPathData: data.randomStationsList,
    callbackToDisplayListItem: railwayStationRouteCallback()
  },
  {
    recommendPathData: data.randomRoutesList,
    callbackToDisplayListItem: stationRoutesCallback(data, data.randomRoutesList)
  },
  {
    recommendPathData: data.randomTrainsList,
    callbackToDisplayListItem: randomTrainCallback()
  }
];

const recommendStaticListIndexSingle = (data) => [
  {
    recommendPathData: data.randomStationsList,
    callbackToDisplayListItem: railwayStationRouteCallback()
  },
  {
    recommendPathData: data.randomRoutesList,
    callbackToDisplayListItem: stationRoutesCallback(data, data.randomRoutesList)
  },
  {
    recommendPathData: data.randomTrainsList,
    callbackToDisplayListItem: randomTrainCallback()
  }
];

const recommendLtsInfoPath = (data) => [
  {
    recommendPathData: data.interlinkingBlocks.otherLtsInterlinkBlocks,
    callbackToDisplayListItem: crossLobCallBacks()
  },
  {
    recommendPathData: data.interlinkingBlocks.routesFromSourceStationInterlinkBlocks,
    callbackToDisplayListItem: randomRouteCallback(data, data.interlinkingBlocks.routesFromSourceStationInterlinkBlocks)
  },
  {
    recommendPathData: data.interlinkingBlocks.routesToDestinationStationInterlinkBlocks,
    callbackToDisplayListItem: randomRouteCallback(
      data,
      data.interlinkingBlocks.routesToDestinationStationInterlinkBlocks
    )
  },
  {
    recommendPathData: data.interlinkingBlocks.popularTrainInterlinkBlocks,
    callbackToDisplayListItem: randomTrainCallback()
  },
  {
    recommendPathData: data.interlinkingBlocks.popularRoutesInterlinkBlocks,
    callbackToDisplayListItem: randomRouteCallback(data, data.interlinkingBlocks.popularRoutesInterlinkBlocks)
  }
];

export const RECOMMEND_PATH = {
  ROUTE_INFO_PAGE: recommendRouteInfoPath,
  TRAIN_INFO_PAGE: recommendTrainInfoPath,
  STATION_INFO_PAGE: recommendStationInfoPath,
  STATIC_LIST_SINGLE: recommendStaticListIndexSingle,
  STATIC_LIST_INDEX: recommendStaticListIndex,
  STATIC_RESERVATION_CANCEL: recommendReservationCancellationPath,
  LTS_INFO_PAGE: recommendLtsInfoPath,
  TRAIN_TYPE_PAGE: recommendedTrainTypeInfoPath
};
